exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Titillium+Web:200,200i,300,300i,400,400i,600,600i,700,700i,900);", ""]);

// module
exports.push([module.id, "body {\n  font-family: 'Titillium Web', sans-serif;\n  padding: 0;\n  margin: 0 !important; }\n\n.dark {\n  background: #2d2d2d;\n  color: #fefefe; }\n\n.is-uppercase {\n  text-transform: uppercase; }\n\n.is-outline {\n  background: transparent;\n  border: 1px solid; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/corpo-leve-www/www/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main